import { render, staticRenderFns } from "./ParticipantViewButton.vue?vue&type=template&id=21b3230e&scoped=true&"
import script from "./ParticipantViewButton.vue?vue&type=script&lang=js&"
export * from "./ParticipantViewButton.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantViewButton.vue?vue&type=style&index=0&id=21b3230e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b3230e",
  null
  
)

export default component.exports